<template>
  <div class="select-location">
    <span
      class="select-text"
      @click="showPopup"
      :class="{ placeholder: !location.c_title }"
    >
      {{ location.c_title || placeholder }}
      <i class="el-icon-arrow-down"></i>
    </span>
    <Popup
      ref="selectPopup"
      v-model="location"
      :hot-data="hotAreaData"
      label-key="c_title"
      value-key="c_id"
      :data="areaData"
      hotTitle="热门城市"
    ></Popup>
  </div>
</template>

<script>
import areaModule from "../utils/area";
import Popup from "./searchPopup";
const hotAreaData = areaModule.getHotAreaData();
export default {
  name: "Location",
  components: {
    Popup
  },
  props: {
    focus: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: "请选择城市"
    }
  },
  data() {
    return {
      location: {},
      areaData: areaModule.getAreasDataAll(),
      selectPopupVisible: false,
      searchText: "",
      hotAreaData: this.focus ? hotAreaData : []
    };
  },
  methods: {
    handleSelect(val) {
      this.$store.commit("setLocation", val);
    },
    showPopup() {
      this.$refs.selectPopup.show();
    }
  },
  created() {
    this.location = this.$store.state.location;
  },
  watch: {
    "$store.state.location": function(val) {
      this.location = val;
    },
    location: function(val) {
      this.handleSelect(val);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.select-location {
  $height: 36px;
  font-size: 14px;
  line-height: $height;
  height: $height;
  .select-text {
    display: block;
    line-height: $height;
    padding: 0 15px;
    position: relative;
    &.placeholder {
      color: #ccc;
      font-size: 13px;
    }
    i {
      font-size: 14px;
      color: #c0c4cc;
      position: absolute;
      right: 12px;
      height: 100%;
      line-height: $height;
    }
  }
}
</style>
